import { X } from "react-feather";
import { Modal } from "reactstrap";
import moment from "moment";
import "./ReleaseVersion.scss";

const ReleaseVersion = ({ data, setReleaseModal, releaseModal }: any) => {
  const releaseDate = data && moment(data?.releaseDate).format("MMM DD, YYYY");

  return (
    <Modal
      centered
      backdrop={true}
      isOpen={releaseModal}
      contentClassName="release-modal"
    >
      <div className="position-absolute" style={{right:'10px', top:'10px'}}> 
        <X
          size={36}
          role="button"
          onClick={() => setReleaseModal(!releaseModal)}
        />
      </div>
      <div className="text-align-center">
        <div className="release-heading">App version info</div>
        <div className="d-flex flex-column align-items-center">
          <div className="version-info">
            Version {data?.name} released at {releaseDate}
          </div>
          <div className="version-info"></div>
          <div className="version-info">{data?.description}</div>
        </div>
      </div>
    </Modal>
  );
};

export default ReleaseVersion;
